import { createFileRoute } from '@tanstack/react-router';

import { PaymentRunReviewPage } from '~pages/payments/payment-run-review';

export const Route = createFileRoute(
  '/_auth/_layout/payment/payment-run-review',
)({
  component: PaymentRunReviewPage,
});
